import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import * as Util from "../Utils/Util";
import Hider from "../Utils/Hider";
import ProductState from "./ProductState";

export default class QuantitySelector {
  private readonly element: HTMLElement;
  private readonly productCode: string;
  private readonly strengthCode: string | null;
  private readonly frequencyCode?: string;
  private readonly selectElement: HTMLSelectElement;

  public constructor(element: HTMLElement) {
    this.element = element;

    this.selectElement = QuantitySelector.getSelector(element);
    this.selectElement.addEventListener("change", (e) => this.handleSelection(e));

    this.productCode = Util.getData(element, "productCode");
    this.strengthCode = Util.getNullableData(element, "strengthCode") || null;
    this.frequencyCode = Util.getNullableData(element, "frequencyCode");

    Events.on("product-state-change", (s: ProductState) => this.handleChangedState(s));
  }

  private shouldShow(state: ProductState): boolean {
    return (
      this.productCode == state.product.code &&
      (this.strengthCode == state.strength.code || this.strengthCode === "") &&
      this.frequencyCode == state.frequency?.code
    );
  }

  private handleChangedState(state: ProductState) {
    const shouldShow = this.shouldShow(state);
    Hider.match(this.element, shouldShow);
    if (shouldShow) {
      this.selectElement.value = state.quantity.code;
    }
    if (Array.from(state.strength.quantities.values()).every((q) => !q.available)) {
      this.selectElement.disabled = true;
    } else {
      this.selectElement.disabled = false;
    }
  }

  private handleSelection(event: Event): void {
    const element: HTMLOptionElement = <HTMLOptionElement>event.target!;
    this.send(element.value!);
  }

  private static getSelector(element: HTMLElement): HTMLSelectElement {
    return element.querySelector("select")!;
  }

  public send(code: string): void {
    Events.fire("quantity-changed", code);
  }

  public static Factory: DomFactory<QuantitySelector> = (e) => new QuantitySelector(e);
}
